// extracted by mini-css-extract-plugin
export default {"container":"WhiteningVideo_container__X1qpr","wrapper":"WhiteningVideo_wrapper__1qKI1"};